import { initNavigationData } from '@/utils/store/perso/persoNavigation';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { PersonalisationState } from './types/index';

export { namespace } from './types/index';

export const state: PersonalisationState = {
  deviceCount: 0,
  instanceNames: [],
  errorMessage: '',
  personalisationState: {
    error: { personalisationList: false },
    loading: { personalisationList: false },
    fetched: { personalisationList: false }
  },
  personalisations: [],
  personalisationDetails: {},
  totalSize: 0,
  navigation: initNavigationData
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
